module.exports = __webpack_public_path__ + "resources/img/img_skyhigh_security_m_en.1b68730f7c501998e8a8ba0cb6248a84.png";